import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

export const step8FinanceSchema = z.object({
  splaftDeclared: z.literal(true, { errorMap: () => ({ message: 'Debe declarar la prevencion LA/FT para continuar' }) }),
  splaftDocumentUploaded: z.boolean(),
}).superRefine((data, ctx) => {
  if (data.splaftDeclared && !data.splaftDocumentUploaded) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['splaftDocumentUploaded'],
      message: 'Debe adjuntar el documento firmado de la declaración SPLAFT',
    })
  }
})

export type Step8FinanceFormValues = z.infer<typeof step8FinanceSchema>

const defaultValues: Step8FinanceFormValues = {
  splaftDeclared: false as unknown as true,
  splaftDocumentUploaded: false,
}

export const useStep8FinanceForm = (props?: { defaultValues?: Step8FinanceFormValues; disabled?: boolean }) => {
  return useZodForm<Step8FinanceFormValues>({
    validationSchema: step8FinanceSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
